import React from 'react'
import { observer } from 'mobx-react-lite'

import { H2, P } from '@mxenabled/mxui'
import { useGlobalCopyStore } from '../../../common'

import { CASHFLOW_IMAGES } from '../../constants/CashflowImages'

const StepTwo: React.FC = () => {
  const { cashflow: customCopy } = useGlobalCopyStore()

  return (
    <React.Fragment>
      <div>
        <img alt="Loading" src={CASHFLOW_IMAGES.CASHFLOW_LOADING_ANIMATION} />
      </div>
      <H2 pb={12} variant="h1">
        {customCopy.loading_title}
      </H2>
      <P>{customCopy.loading_description}</P>
    </React.Fragment>
  )
}

export default observer(StepTwo)
